import {css} from "../libs/lit.dist.js";

export default css`
    * {
        box-sizing: border-box;
    }

    :host {
        --z-index: 2050;
        --border-radius: 0.5rem;
        --header-padding-y: 1.25rem;
        --header-padding-x: 1.5rem;
    }

    .modal {
        position: fixed;
        top: 0;
        left: 0;
        z-index: var(--z-index);
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        background-color: rgba(0, 0, 0, 0);
        transition: background-color 0.3s,
                    opacity 0.2s;
        opacity: 0;
    }

    :host(.opened) .modal {
        opacity: 1;
        transition: background-color 0.3s,
                    opacity 0.2s;
        background-color: rgba(0, 0, 0, 0.2);
    }

    .modal-dialog {
        position: relative;
        width: auto;
        margin: 0.5rem;
        pointer-events: auto;
        transform: translateY(-4rem);
        transition: transform 0.3s ease-out, width 0.3s ease-out, max-width 0.3s ease-out
    }

    .modal-dialog-right {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        margin: 0 !important;
        border-width: 0;
        transform: translateX(30%);
        --border-radius: 0;

        .modal-content {
            min-height: 100%;
        }
        
        .dialog-header {
            position: sticky;
            top: 0;
            z-index: var(--z-index);
        }
    }

    .modal-with-header .modal-body {
        /*padding-top: 0;*/
    }

    :host(.opened) .modal-dialog {
        transform: translateY(0);

        &.modal-dialog-right {
            transform: translateX(0);
        }
    }
    
    :host(.dialog-style-frosty) {
        --dialog-background: rgba(255, 255, 255, 0.75);
        --dialog-backdrop-filter: blur(1rem);
        --dialog-header-color: var(--gray-800);
        --dialog-header-background: none;
    }

    .modal-content {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        background: var(--dialog-background, #fff);
        backdrop-filter: var(--dialog-backdrop-filter);
        background-clip: padding-box;
        border: 0 none;
        outline: 0;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
        border-radius: var(--border-radius);
    }

    .dialog-header {
        display: flex;
        align-items: center;
        width: 100%;
        padding: var(--header-padding-y) var(--header-padding-x);
        background: var(--dialog-header-background, linear-gradient(250deg, #3e93d6, var(--theme-primary-400)));
        color: var(--dialog-header-color, #fff);
        margin-bottom: 0;
        font-size: 0.75rem;
        white-space: nowrap;
        line-height: 1.3;
        font-weight: 400;
        border-radius: var(--border-radius) var(--border-radius) 0 0;
        border-bottom: 1px solid var(--dialog-header-border-color);
    }

    .modal-body {
        position: relative;
        flex: 1 1 auto;
        padding: 1.25rem;
    }

    .dialog-title {
        font-size: 0.9375rem;
        font-weight: normal;
        margin: 0;
    }

    .dialog-controls {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 0.75rem;
    }
    
    .dialog-controls button {
        font-size: 1.21875rem;
        font-weight: 700;
        line-height: 1;
        color: var(--dialog-header-color, white);
        text-shadow: 0 1px 0 var(--dialog-header-color, white);
        opacity: .5;
        padding: 0;
        background-color: transparent;
        border: 0;
        cursor: pointer;
        margin-left: 0.25rem;
        margin-right: 0.25rem;
    }

    slot[name="buttons"]::slotted(.btn),
    slot[name="buttons"]::slotted(.buttons),
    slot[name="controls"]::slotted(.btn),
    slot[name="controls"]::slotted(.buttons),
    slot[name="title"]::slotted(.btn),
    slot[name="title"]::slotted(.buttons) {
        margin-top: calc(var(--header-padding-y) / 2 * -1) !important;
        margin-bottom: calc(var(--header-padding-y) / 2 * -1) !important;
    }
    
    :host([stickyheader]) .dialog-header {
        position: sticky;
        top: var(--header-sticky-offset, 0);
        z-index: 501;
    }

    .dialog-controls *:focus {
        outline: 1px dotted #000;
    }
    
    .dialog-controls .close-button,
    .dialog-controls .minimize-button {
        --__dialog-close-button-background: var(--dialog-close-button-background, url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e"));
        -webkit-mask: var(--__dialog-close-button-background) no-repeat 50% 50%;
        mask: var(--__dialog-close-button-background) no-repeat 50% 50%;
        -webkit-mask-size: cover;
        mask-size: cover;
        background-color: currentColor;
        width: var(--dialog-control-button-size, 0.75rem);
        height: var(--dialog-control-button-size, 0.75rem);
        display: block;
        opacity: 0.75;
        transition: all 0.2s;
        
        &:hover {
            opacity: 1;
        }
        
        &:focus-visible {
            scale: 1.5;
            rotate: 90deg;
            transition: all 0.2s;
        }
    }
    
    .dialog-controls .minimize-button {
        --__dialog-close-button-background: var(--dialog-minimize-button-background, url("data:image/svg+xml,%3Csvg version='1.1' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m1.2347 14.812h13.514' fill='none' stroke='%23000' stroke-linecap='round' stroke-width='2'/%3E%3C/svg%3E"));
    }
    
    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 500px;
            margin: 1.75rem auto;
        }

        .modal-sm {
            max-width: 300px;
        }

        .modal-max {
            max-width: calc(100% - 1rem) !important;
        }
    }

    @media (min-width: 992px) {
        .modal-lg,
        .modal-xl {
            max-width: 800px;
        }

        .modal-max {
            max-width: calc(100% - 2rem) !important;
        }
    }

    @media (min-width: 1399px) {
        .modal-xl {
            max-width: 1140px;
        }
    }
`;
